<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Payment Transaction Daily Report</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                <v-col sm="4" md="2" cols="12">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="payment_type" return-object
                        :items="payment_type_list" item-text="type" label="Select Payment Type" outlined
                        @change="getpayment_mode()" @click="show = false" persistent-hint
                        hint="Please Select Payment Type" />
                </v-col>
                <v-col sm="4" md="2" cols="12">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="payment_purpose_type" return-object
                        :items="Payment_purpose_type_list" item-text="type" label="Select Payment Purpose" outlined
                        @click="show = false" persistent-hint hint="Please Select Payment Purpose" />
                </v-col>
                <v-col sm="4" md="2" cols="12" v-if="payment_type">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="payment_mode" return-object
                        :items="payment_mode_list" item-text="name" label="Select Payment Mode" outlined
                        @click="show = false" persistent-hint hint="Please Select Payment Mode" />
                </v-col>
                <v-col sm="12" md="6" cols="12">
                    From Date ::
                    <input id="datePickerId" type="date" v-model="fromdate" @click="show = false" />
                    To Date ::
                    <input id="datePickerId" type="date" v-model="todate" @click="show = false" /> (inclusive)
                    <!-- <v-btn
          v-if="payment_type && payment_purpose_type && fromdate && todate"
          :loading="loader"
          class="button"
          @click="
            proceed();
            show = true;
          "
          >Proceed</v-btn
        > -->
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-switch color="#0F2027" v-model="sort_date_wise" label="Sort Date Wise"></v-switch>
                </v-col>
            </v-row>
            <v-row dense justify="center">
                <v-btn v-if="payment_type && payment_purpose_type && fromdate && todate" :loading="loader"
                    class="button" @click="
                        proceed();
                    ">
                    Proceed
                </v-btn>
            </v-row>
            <!-- {{student_out_list}}
          -----------------------
          {{student_misc_list}}
          -----------------------
          {{student_inst_list}} -->
        </v-card>
        <v-card class="box" v-if="filteredItems.length > 0 && show">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Payment Transaction Daily Report</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <!-- shiv code -->
            <v-row dense class="no-display">
                <v-col cols="12" sm="3" md="3">
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <v-btn rounded color="success" outlined @click="
                                fnExcelReport('my-table-id', 'PaymentDailyTransactionReport')
                                " :loading="loader">
                                <v-icon color="success">mdi-export</v-icon>Export
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon
                                    left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <v-btn class="ma-2 no-display" tile outlined color="warning" @click="showLogo()">
                                Hide /Show Logo
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>

                <v-col cols="12" sm="9" md="9">
                    <v-row dense>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="ay" label="Admission Year"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="purpose" label="Purpose"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="payMode" label="Payment Mode "></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="transId" label="Transaction Id "></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="remark" label="Remark "></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="amount" label="Amount "></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="fine" label="Fine "></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="total_amt" label="Total Amount "></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="date1" label="Date "></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="cre_by" label="Created By "></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="up_by" label="Updated By "></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="cre_date" label="Created Date "></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-checkbox v-model="up_date" label="Updated Date "></v-checkbox>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <!-- header code -->
            <!-- <div c lass="org-data" v-if="org_basic_data"> -->
            <!-- <v-simple-table dense class="elevation-1 table-container">
        <template v-slot:default>
          <thead>
            <tr>
              <th v-if="org_basic_data.trust_logo" style="width: 14%">
                <img
                  :src="org_basic_data.trust_logo"
                  width="90%"
                  alt="logo"
                />
              </th>
              <td>
                <center>
                  <tr v-if="org_basic_data.trust_name">
                    <strong>{{ org_basic_data.trust_name }}</strong>
                  </tr>
                  <tr v-if="org_basic_data.school_name">
                    <strong>{{ org_basic_data.school_name }} </strong>
                  </tr>
                  <tr v-if="org_basic_data.address">
                    {{
                      org_basic_data.address
                    }}
                  </tr>
                  <tr v-if="org_basic_data.phone">
                    Phone :
                    {{
                      org_basic_data.phone
                    }}
                  </tr>
                  <tr v-if="org_basic_data.email">
                    Email :
                    {{
                      org_basic_data.email
                    }}
                  </tr>
                  <tr v-if="org_basic_data.website">
                    Website :
                    {{
                      org_basic_data.website
                    }}
                  </tr>
                </center>
              </td>
              <th v-if="org_basic_data.school_logo" style="width: 14%">
                <center>
                  <img
                    :src="org_basic_data.school_logo"
                    width="80%"
                    alt="logo"
                  />
                </center>
              </th>
            </tr>
          </thead>
        </template>
</v-simple-table> -->

            <!-- <v-row dense>
        <v-col
          cols="12"
          sm="4"
          md="2"
          v-if="org_basic_data.trust_logo"
          align="center"
        >
          <img
            :src="org_basic_data.trust_logo"
            alt="logo"
            class="trust-logo"
          />
        </v-col>
        <v-col cols="12" sm="4" md="8">
          <center>
            <h2>
              <strong>{{ org_basic_data.trust_name }}</strong>
            </h2>
            <h3>
              <strong>{{ org_basic_data.school_name }} </strong>
            </h3>
            <span>{{ org_basic_data.address }}</span> <br />
            <span>Phone :{{ org_basic_data.phone }} </span> <br />
            <span>Email :{{ org_basic_data.email }} </span> <br />
            <span>Website :{{ org_basic_data.website }} </span> <br />
          </center>
        </v-col>
        <v-col cols="12" sm="4" md="2" v-if="org_basic_data.school_logo">
          <img
            :src="org_basic_data.school_logo"
            alt="logo"
            class="schl-logo"
          />
        </v-col>
      </v-row> -->

            <!-- </div> -->
            <!-- header code end -->
            <v-row>
                <v-col cols="12" sm="3">
                    <v-autocomplete flat hide-details rounded dense outlined label="Standard" multiple clearable
                        :items="dataValueList('standard')" v-model="filters.standard"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-autocomplete flat hide-details rounded dense outlined label="Admission Year" multiple clearable
                        :items="dataValueList('learner_addmission_year')"
                        v-model="filters.learner_addmission_year"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-autocomplete flat hide-details rounded dense outlined label="Registration No." multiple clearable
                        :items="dataValueList('registration_number')"
                        v-model="filters.registration_number"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-autocomplete flat hide-details rounded dense outlined label="Name" multiple clearable
                        :items="dataValueList('name')"
                        v-model="filters.name"></v-autocomplete>
                </v-col>
            </v-row>
            <br />
            <div id="my-table-id">
                <div v-if="org_basic_data">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="4" md="2" v-if="org_basic_data.trust_logo && show_logo" align="center">
                            <img :src="org_basic_data.trust_logo" alt="logo" class="trust-logo" />
                        </v-col>
                        <v-col cols="12" sm="4" md="8">
                            <center>
                                <h2>
                                    <strong>{{ org_basic_data.trust_name }}</strong>
                                </h2>
                                <h3>
                                    <strong>{{ org_basic_data.school_name }} </strong>
                                </h3>
                                <span>{{ org_basic_data.address }}</span> <br />
                                <span>Phone :{{ org_basic_data.phone }} </span> <br />
                                <span>Email :{{ org_basic_data.email }} </span> <br />
                                <span>Website :{{ org_basic_data.website }} </span>
                                <br />
                            </center>
                        </v-col>
                        <v-col cols="12" sm="4" md="2" v-if="org_basic_data.school_logo && show_logo">
                            <img :src="org_basic_data.school_logo" alt="logo" class="schl-logo" />
                        </v-col>
                    </v-row>
                </div>
                <div>
                    <center>
                        <b> <span>Payment Transaction Report {{ fromdate }} to {{ todate }}</span></b>
                    </center>
                </div>
                <v-row dense justify="end" class="no-display">
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                        v-model="searchQuery"
                        dense
                        clearable
                        outlined
                        label="Search"
                        prepend-inner-icon="mdi-magnify"
                        hide-details
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-simple-table fixed-header height="500px" dense class="elevation-1 stud-table">
                    <thead>
                        <tr>
                            <th class="sticky-col sticky-col-1">PRN No./Form No.</th>
                            <th class="sticky-col sticky-col-2">Name</th>
                            <th class="sticky-col sticky-col-3">Standard</th>
                            <th class="sticky-col sticky-col-4">Quota</th>
                            <th v-if="ay" class="sticky-col sticky-col-5">Admission Year</th>
                            <th v-if="purpose">Purpose</th>
                            <th v-if="payMode">Payment Mode</th>
                            <th v-if="transId">
                                Transaction Id (Only for online Transaction)
                            </th>
                            <th>DD / Check NO</th>
                            <th v-if="remark">Remark</th>
                            <th>Receipt No.</th>
                            <th v-if="amount">Paid Amount</th>
                            <th v-if="fine">Fine</th>
                            <th v-if="total_amt">Total Paid Amount</th>
                            <th v-if="date1">Receipt Date</th>
                            <th v-if="date1">Transaction Date</th>
                            <th v-if="cre_by">Created By</th>
                            <th v-if="up_by">Updated By</th>
                            <th v-if="cre_date">Created Date</th>
                            <th v-if="up_date">Updated Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in filteredItems" :key="item.id">
                            <!-- <tr v-for="item in filteredItems" :key="item.id"> -->
                            <td class="sticky-col sticky-col-1">{{ item.registration_number }}</td>
                            <td class="sticky-col sticky-col-2">{{ item.name }}</td>
                            <td class="sticky-col sticky-col-3">{{ item.standard }}</td>
                            <td class="sticky-col sticky-col-4">{{ item.quota }}</td>
                            <td v-if="ay" class="sticky-col sticky-col-5">{{ item.learner_addmission_year }}</td>
                            <td v-if="purpose">{{ item.type }}</td>
                            <td v-if="payMode">{{ item.mode }}</td>
                            <td v-if="transId">{{ item.trxn_id }}</td>
                            <td>{{ item.transaction_id }}</td>
                            <td v-if="remark">{{ item.remark }}</td>
                            <td>{{ item.receipt_no }}</td>
                            <td v-if="amount">{{ item.amount }}</td>
                            <td v-if="fine">{{ item.fine }}</td>
                            <td v-if="total_amt">{{ item.total_amt }}</td>
                            <td v-if="date1">{{ item.date }}</td>
                            <td v-if="date1">{{ item.tranx_date }}</td>
                            <td v-if="cre_by">{{ item.created_by }}</td>
                            <td v-if="up_by">{{ item.updated_by }}</td>
                            <td v-if="cre_date">{{ item.creation_date }}</td>
                            <td v-if="up_date">{{ item.updation_date }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="11">Total</td>
                            <td v-if="amount">{{ totalPaidAmount }}</td>
                            <td v-if="fine">{{ totalFine }}</td>
                            <td v-if="total_amt">{{ totalTotalPaid }}</td>
                            <td colspan="6"></td>
                        </tr>
                    </tfoot>
                </v-simple-table>
            </div>
            <!-- table end -->
        </v-card>
    </div>
</template>
<script>
// import "@/assets/css/xlsx.full.min";
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Datepicker,
        Breadcrumbs
    },
    data: () => ({
        snackbar_msg: "",
        color: "",
        snackbar: false,
        fromdate: null,
        todate: null,
        searchQuery:"",
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        show_logo: true,
        payment_type_list: [
            { id: 1, type: "All" },
            { id: 2, type: "Online" },
            { id: 3, type: "Offline" },
        ],
        payment_type: null,
        payment_purpose_type: null,
        Payment_purpose_type_list: [
            { id: 1, type: "All" },
            { id: 2, type: "Student Installment Fee" },
            { id: 3, type: "Student Outstanding Fee" },
            { id: 4, type: "Student Misc. Fee" },
            { id: 5, type: "Student Canteen Fee" },
            { id: 5, type: "Student Elective Fee" },
            { id: 5, type: "Student Form Fee" },
        ],
        payment_mode: null,
        payment_mode_list: [],
        payment_mode_list_online: [{ id: 1, name: "Online" }],
        instData: [],
        miscData: [],
        outData: [],
        canteenData: [],
        electiveData:[],
        show: false,
        loader: false,
        ay: true,
        search1: "",
        purpose: true,
        payMode: true,
        transId: true,
        remark: true,
        amount: true,
        date1: true,
        cre_by: true,
        up_by: true,
        cre_date: true,
        up_date: true,
        fine: true,
        total_amt: true,
        sort_date_wise: false,
        org_basic_data: [],
        filters: {
            standard: [],
            learner_addmission_year: [],
            registration_number:[],
            name:[],
        },
    }),
    methods: {
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //   type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const filename = name + ".xls";

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        showLogo() {
            if (this.show_logo) {
                this.show_logo = false;
            } else {
                this.show_logo = true;
            }
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        getpayment_mode() {
            const data = {
                payment_type: this.payment_type,
            };
            axios
                .post("/AccountingAndFeesReports/getPaymentMode", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.payment_mode_list = res.data.mode_details;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    this.loader = false;
                });
        },
        proceed() {
            this.loader = true;
            this.search1 = "";
            this.ay = true;
            this.show = false;
            const data = {
                payment_type: this.payment_type,
                payment_purpose_type: this.payment_purpose_type,
                payment_mode: this.payment_mode,
                fromdate: this.fromdate,
                todate: this.todate,
                sort_date_wise: this.sort_date_wise,
            };
            axios
                .post("/AccountingAndFeesReports/getDailyPaymentReport", data)
                .then((res) => {
                    this.outData = res.data.student_out_list;
                    this.miscData = res.data.student_misc_list;
                    this.instData = res.data.student_inst_list;
                    this.canteenData = res.data.student_canteen_list;
                    this.electiveData = res.data.student_elective_list
                    this.org_basic_data = res.data.org_basic_data;
                    this.show = true;
                    this.loader = false;
                })
                .catch((error) => {
                    window.console.log(error);
                    this.showSnackbar("#b71c1c", "Something went wrong");
                    this.loader = false;
                })
                .finally(() => {
                    this.loader = false;
                    this.dataTable = $("#admitted-student-report").DataTable({
                        colReorder: true,
                        dom: "Bfrtip",
                        buttons: ["csvHtml5", "excelHtml5", "print"],
                    });
                    this.dataTable = $("#admitted-student").DataTable({
                        colReorder: true,
                        dom: "Bfrtip",
                        buttons: ["csvHtml5", "excelHtml5", "print"],
                    });
                });
        },
        dataValueList(column) {
            return [...new Set(this.allStudentLists.map((item) => item[column]))];
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() { },
    computed: {
        totalPaidAmount() {
            return this.filteredItems.reduce((sum, item) => sum + (item.amount || 0), 0);
        },
        totalFine() {
            return this.filteredItems.reduce((sum, item) => sum + (item.fine || 0), 0);
        },
        totalTotalPaid() {
            return this.filteredItems.reduce((sum, item) => sum + (item.total_amt || 0), 0);
        },
        allStudentLists() {
            return [
                ...(this.outData || []),
                ...(this.miscData || []),
                ...(this.instData || []),
                ...(this.canteenData || []),
                ...(this.electiveData || []),
            ];
            },
            filteredItems() {
                return this.allStudentLists.filter((item) => {
                    const matchesStd = this.filters.standard.length ? this.filters.standard.includes(item.standard) : true;
                    const matchesAY = this.filters.learner_addmission_year.length ? this.filters.learner_addmission_year.includes(item.learner_addmission_year) : true;
                    const matchesreg_no = this.filters.registration_number.length ? this.filters.registration_number.includes(item.registration_number) : true;
                    const matchesname = this.filters.name.length ? this.filters.name.includes(item.name) : true;

                    const query = this.searchQuery ? this.searchQuery.toLowerCase() : "";
                    const matchesSearch = query
                    ? (
                        (item.registration_number || "").toString().toLowerCase().includes(query) ||
                        (item.name || "").toLowerCase().includes(query) ||
                        (item.receipt_no || "").toString().toLowerCase().includes(query) ||
                        (item.trxn_id || "").toString().toLowerCase().includes(query)
                        )
                    : true;

                    return matchesStd && matchesAY && matchesSearch && matchesreg_no && matchesname;
                });
            },       
    },
};
</script>
<style scoped>
input[type="date"] {
    width: 30%;
    display: inline-block;
    padding: 0.3rem;
    border: 1px solid gray;
    border-radius: 30px;
    box-sizing: border-box;
    padding-top: none !important;
    margin-top: none !important;
}

.dt-button {
    font-size: small;
    font-weight: bold;
}

.dt-button.buttons-print::before {
    content: "\F42A";
    margin-right: 8px;
    margin-top: 8px;
    font-size: small;
}

.dt-button.buttons-excel::before {
    content: "\F21B";
    margin-right: 8px;
    margin-top: 8px;
    font-size: small;
}

.dt-button.buttons-csv::before {
    content: "\FEC2";
    margin-right: 8px;
    margin-top: 8px;
    font-size: small;
}

button.dt-button:hover:not(.disabled),
div.dt-button:hover:not(.disabled),
a.dt-button:hover:not(.disabled) {
    border-color: #ff9800;
    color: #ff9800;
}

.dataTables_wrapper .dataTables_filter input[type="search"] {
    border-radius: 2px;
    border: 1px solid #cdcdcd;
    cursor: auto;
    white-space: nowrap !important;
}

.scroll {
    overflow-x: scroll;
}

.text-color {
    font-weight: bold;
    color: red;
    font-size: small;
}

tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
    font-size: small;
}

td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
    font-size: small;
}


@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
}

.trust-logo {
    width: 86%;
}

.schl-logo {
    width: 86%;
}

.stud-table {
  overflow-x: auto;
  overflow-y: auto;
}

.sticky-col {
  position: sticky;
  background-color: white;
  z-index: 3;
}

.sticky-col-1 { left: 0px;    width: 100px; min-width: 100px; }
.sticky-col-2 { left: 100px;  width: 140px; min-width: 140px; }
.sticky-col-3 { left: 240px;  width: 90px;  min-width: 90px; }
.sticky-col-4 { left: 330px;  width: 90px;  min-width: 90px; }
.sticky-col-5 { left: 420px;  width: 120px; min-width: 120px; }

thead .sticky-col {
  z-index: 4;
  box-shadow: inset 0 -1px 0 #ccc;
}

.sticky-col-4,
.sticky-col-5 {
  box-shadow: 2px 0 4px -2px rgba(0,0,0,0.2);
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    img {
        width: 100% !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    /* .stud-table {
  overflow-x: hidden !important;
} */
    .box {
        background-color: white !important;
        /* margin: 8px !important;
  padding: 8px; */
        border: none !important;
        /* overflow: hidden !important; */
    }

    /* tr,
td,
th {
  font-size: large !important;
} */

    @page {
        size: A4;
        margin-top: none !important;
        padding-top: none;
        /* size: 16in 17in; */
        size: 20in 17in;
    }
}
</style>
